import { ArrowUpOutlined, ArrowLeftOutlined, CheckCircleFilled, PhoneFilled, PaperClipOutlined } from "@ant-design/icons";
import {
    Breadcrumb,
    Button,
    Col,
    DatePicker,
    Divider,
    Form,
    Input,
    Row,
    Select,
    Space,
    theme,
    Typography,
    Radio,
    InputNumber,
    Card,
    FloatButton,
} from "antd";
import React, { useState, useEffect, useCallback } from "react";
import Heading from "../../../components/common/heading";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import WithSidebar from "../../../templates/withSidebar";
import { useNavigate, useLocation } from "react-router-dom";
import { routes } from "../../../routes";
import Validation, { agency_All, questionnaire } from "./components/dataReport";
import { getQuestion } from "../../../services/customerTouchPoint";
import useTouchpoint from "../../../lib/hooks/useTouchpoint";
import { downloadFile } from "../../../services/uploadFile";
import { APPCONFIG } from "../../../Config";
import APIEndpoint from "../../../services/endpoint";


import useMasterData from "../../../lib/hooks/useMasterData";
import {
  ACCESS_TOKEN,
  BUSINESS_REQUIRE,
  COMPANY_TYPE,
  CUSTOMER_EXPECT,
  CUSTOMER_SUPPORT,
  DATA_MASTER_DATA_TYPE,
  EXPECTED,
  INDUSTRY,
  INDUSTRY_TYPE,
  OTHER_BUSINESS_EXPECT,
  OTHER_PRODUCT_EXPECT,
  OTHER_SUPPORT_EXPECT,
  PRODUCT_REQUIREMENT,
  PROVICE,
  REGION_GROUP,
  SUCCESS_CODE,
  TOUCH_POINT_CHANNEL,
  VOC_MASTER_DATA_TYPE,
  WORK_PERIOD,
} from "../../../lib/const";

const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text, Link } = Typography;
const { Option } = Select;
const { TextArea } = Input;

export const ViewTouchPointPage = () => {
     let k =0;
     const [customerExpect] = useMasterData(VOC_MASTER_DATA_TYPE, CUSTOMER_EXPECT);

const [productRequirement] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    PRODUCT_REQUIREMENT
  );
 
const [customerSupport] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    CUSTOMER_SUPPORT
  );
  const [customerExpact, setCustomerExpact] = useState({
    type: "customer_expect",
    detail: [],
  });
 const [businessRequire] = useMasterData(
     VOC_MASTER_DATA_TYPE,
     BUSINESS_REQUIRE
   );
   const [otherProductExpect] = useMasterData(
      VOC_MASTER_DATA_TYPE,
      OTHER_PRODUCT_EXPECT
    );
    const [otherSupportExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_SUPPORT_EXPECT
  );
  const [otherBusinessExpect] = useMasterData(
     VOC_MASTER_DATA_TYPE,
     OTHER_BUSINESS_EXPECT
   );
  const [otherExpect, setOtherExpect] = useState({
    type: "other_expect",
    detail: [],
  });
    const navigate = useNavigate();
    const { setQuestionValues, setHeaderValues, headerValues } = useTouchpoint();
    const location = useLocation();
    const { token } = useToken();
    const [form] = Form.useForm();
    const { setOpenCancelModal, setPreviousPage } = useCancelModal();
    const [actionType, setActionType] = useState(location.state.action_type);
    const [agencyName, setAgencyName] = useState(location.state.agency_name);
    const [agencyType, setAgencyType] = useState(location.state.agency_type);
    const [agencyChannel, setAgencyChannel] = useState(location.state.agency_channel);
    const [agencyDetail, setAgencyDeatil] = useState(location.state.agency_detail.questionDetail);
    const [vocDetail, setVocDetail] = useState(location.state.agency_detail?.vocDetail);
    const [agencyHeader, setAgencyHeader] = useState(location.state.agency_header);
    const [header, setHeader] = useState(location.state.header);
    const [detailChannel, setDetailChannel] = useState(location.state.detailChannel);
    const [questionHeader, setQuestionHeader] = useState([]);
    const [valueQ1, setValueQ1] = useState(2);
    const [value, setValue] = useState(1);
    const [chkData, setChkData] = useState(location.state.status_data);
    const [fileName, setFileName] = useState("");

    const onChangePage = () => {
        setOpenCancelModal(true);
    };

    const DownloadFile = async (fileName) => {
        const res = await downloadFile(fileName);

        if (res.headers["content-type"] === "application/octet-stream" || res.headers["content-type"] === "application/pdf") {
            // for pdf type
            const blobFile = new Blob([res.data], {
                type: "application/pdf",
            });
            const href = URL.createObjectURL(blobFile);
            const downloadLink = document.createElement("a");
            downloadLink.href = href;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
        } else {
            // for image type
            const { objectValue } = res.data;
            if (objectValue) {
                //const href = `${"data:" + res.headers["content-type"] + ";base64," + objectValue.bytes}`;
                //const downloadLink = document.createElement("a");
                //downloadLink.href = href;
                //downloadLink.download = objectValue.fileName;
                //document.body.appendChild(downloadLink);
                //downloadLink.click();
            }
        }
    };


    // form.setFieldsValue({
    //   productRequirement: Object.values(vocDetail.productAndServiceExpected ?? {}).flat()
    // });

    const getQuestionData = useCallback(async () => {
        if (actionType === "EDIT") {
            const res = await getQuestion(agencyType, agencyChannel);
            // const res = await getQuestion("39754a17-6a8e-95d4-ba9c-82086244b353", "Website");
            if (res.data.code === "0000") {
                setQuestionHeader(res.data.objectValue);
                //console.log("1.) res.data.objectValue===>");
                //console.log(res.data.objectValue);
            }
        } else {
            const res = await getQuestion(agencyType, agencyChannel);
            if (res.data.code === "0000") {
                setQuestionHeader(res.data.objectValue);
                //console.log("2.) res.data.objectValue===>");
                //console.log(res.data.objectValue);
            }
        }
    }, [questionHeader]);

    // const getNameFile = useCallback(async () => {
    //     if (agencyDetail.length >= 7) {
    //         const res = await downloadFile(
    //             agencyDetail.length === 9 
    //             ? agencyDetail[8].answer 
    //             : agencyDetail.length === 8
    //             ? agencyDetail[7].answer 
    //             : agencyDetail[6].answer);
    //         setFileName(res.data.objectValue.fileName);
    //     }
    // }, [fileName]);

    useEffect(() => {
        getQuestionData();
        setHeaderValues(header);
        //getNameFile();
console.log("vocDetail to set ===>");
console.log(vocDetail)
console.log("===>Debug");
console.log(Object.values(vocDetail.productAndServiceExpected ?? {}).flat()==""? null :Object.values(vocDetail.productAndServiceExpected ?? {}).flat() )
console.log("===>Debug");
/*
const productExpected = Object.values(vocDetail.productAndServiceExpected ?? {}).flat();

form.setFieldsValue({
  productAndServiceExpected: productExpected.length ? productExpected : null,
});

*/
//const productExpected = Object.values(vocDetail.productAndServiceExpected ?? {}).flat();


// form.setFieldsValue({
//     productAndServiceWant:  Object.values(vocDetail.productAndServiceWant ?? {}).flat()
// });
// form.setFieldsValue({
//     productAndServiceExpected: Object.values(vocDetail.productAndServiceExpected ?? {}).flat()
// });

// form.setFieldsValue({
//     transactionWant:  Object.values(vocDetail.transactionWant ?? {}).flat()
// });
// form.setFieldsValue({
//     transactionExpected:  Object.values(vocDetail.transactionExpected ?? {}).flat()
// });

// form.setFieldsValue({
//     supportWant:  Object.values(vocDetail.supportWant ?? {}).flat()
// });
// form.setFieldsValue({
//     supportExpected:  Object.values(vocDetail.supportExpected ?? {}).flat()
// });

// form.setFieldsValue({
//     crmExpected:  Object.values(vocDetail.crmExpected ?? {}).flat()
// });

const flatOrNull = (obj) => {
  const arr = Object.values(obj ?? {}).flat();
   if(arr==""){
     return null;
   }
  return arr.length ? arr : null;
};
const flatText = (obj) => {
  return obj;
  //return Object.values(obj ?? {})[0] ?? "";
};
form.setFieldsValue({
  productAndServiceWant: flatOrNull(vocDetail.productAndServiceWant),
  productAndServiceExpected: flatOrNull(vocDetail.productAndServiceExpected),
  transactionWant: flatOrNull(vocDetail.transactionWant),
  transactionExpected: flatOrNull(vocDetail.transactionExpected),
  supportWant: flatOrNull(vocDetail.supportWant),
  supportExpected: flatOrNull(vocDetail.supportExpected),
  crmExpected: flatOrNull(vocDetail.crmExpected),
  productAndServiceSuggestion: flatText(vocDetail.productAndServiceSuggestion),
  supportSuggestion: flatText(vocDetail.supportSuggestion),
  transactionSuggestion: flatText(vocDetail.transactionSuggestion),
  crmSuggestion: flatText(vocDetail.crmSuggestion),
  notSatisfied: flatText(vocDetail.notSatisfied),
});

// form.setFieldsValue({
//     productAndServiceSuggestion:    Object.values(vocDetail.productAndServiceSuggestion  ?? {}).flat()
// });

// form.setFieldsValue({
//     supportSuggestion:    Object.values(vocDetail.supportSuggestion  ?? {}).flat()
// });
// form.setFieldsValue({
//     transactionSuggestion:    Object.values(vocDetail.transactionSuggestion  ?? {}).flat()
// });
// form.setFieldsValue({
//     crmSuggestion:    Object.values(vocDetail.crmSuggestion  ?? {}).flat()
// });
// form.setFieldsValue({
//     notSatisfied:    Object.values(vocDetail.notSatisfied  ?? {}).flat()
// });
console.log("set value Finish");
    }, []);

    // console.log("T_VIEW", actionType);
    // console.log(chkData);
    // console.log(agencyType);
    // console.log(agencyChannel);
    // console.log(agencyHeader);
    //console.log(agencyDetail);
    // console.log("length", agencyDetail.length);
    // console.log(header[0]);
    //  console.log(detailChannel.questionDetail);
    //console.log(agencyDetail);
    //console.log("agencyDetail length", agencyDetail.length);

     console.log("vocDetail===>");
    console.log(vocDetail);
     console.log("Object.values(vocDetail.productAndServiceExpected ?? {}).flat()====>");
    console.log(Object.values(vocDetail.productAndServiceExpected ?? {}).flat());
  console.log("productRequirement===>");
    console.log(productRequirement);
    //console.log("vocDetail length", vocDetail.length);
  
    return (
        <WithSidebar>
            <div>
                <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
                    <Col span={24}>
                        <div className="flex items-center">
                            <Space size={12}>
                                <Button
                                    type="link"
                                    onClick={() => {
                                        setOpenCancelModal(true);
                                        setPreviousPage(routes.customer_tab_touchpoint);
                                    }}
                                    style={{ padding: 0 }}
                                >
                                    <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                                </Button>
                                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
                            </Space>
                        </div>
                        <Breadcrumb
                            style={{ paddingTop: 10 }}
                            items={[
                                {
                                    title: "คลังข้อมูล Touch point ",
                                },
                                {
                                    title: <span className="pr_green">รายละเอียด</span>,
                                },
                            ]}
                        />
                    </Col>

                    <Col span={24}>
                        <Form form={form} layout="vertical" style={{ width: "100%", padding: "0 30px" }}>
                            <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                                {actionType != "VIEW" && (
                                    <>
                                        <Col span={24} align="right">
                                            <Space>
                                                <Button
                                                    type="primary"
                                                    onClick={() =>
                                                        navigate(routes.add_customer_touchpoint_page, {
                                                            state: {
                                                                id: 1,
                                                                agency_type: agencyType,
                                                                agency_name: agencyName,
                                                                agency_channel: agencyChannel,
                                                                action_type: actionType,
                                                                agency_header: agencyHeader,
                                                                action_sub_type: actionType === "CREATE" ? "PRE" : "POST",
                                                                status_data: chkData,
                                                                agency_detail: JSON.parse(localStorage.getItem(agencyChannel)),
                                                                header: [
                                                                    {
                                                                        id: header[0].id,
                                                                        agency: agencyType,
                                                                        quarter: header[0].quarter,
                                                                        line_of_work: header[0].line_of_work ? header[0].line_of_work : "",
                                                                        industrial_name: header[0].industrial_name ? header[0].industrial_name : "",
                                                                        name_reporter: header[0].name_reporter,
                                                                        position_reporter: header[0].position_reporter,
                                                                        tel_reporter: header[0].tel_reporter,
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                    }
                                                >
                                                    แก้ไข
                                                </Button>
                                            </Space>
                                        </Col>
                                    </>
                                )}
                            </Row>
                            <Row gutter={[8, 16]} className="card">
                                <Col span={24}>
                                    <Heading text={agencyName} size={4} style={{ margin: 0, color: "#499D96" }} />
                                </Col>
                                <Col span={16}>
                                    <Text style={{ whiteSpace: "pre-line" }}>{agencyHeader}</Text>
                                </Col>
                            </Row>
                            <Row gutter={[8, 16]} className="card" style={{ marginTop: 10 }}>
                                <Col span={24}>
                                    <Heading text={"ผลการดำเนินงานตามมาตรฐานการให้บริการ"} size={4} style={{ margin: 0, color: token.thPrimary }} />
                                </Col>
                                <Col span={16}>
                                    <Form.Item label={<Text className="pr_green">{questionHeader[0]?.question}</Text>} name={"question_1"}>
                                        <Text>{agencyDetail.length === 9 ? agencyDetail[0].answer : agencyDetail[0].answer}</Text>
                                    </Form.Item>
                                </Col>

                                {agencyDetail[0].answer != "เป็นไปตามมาตรฐาน" && (
                                    <>
                                        <Col span={16}>
                                            <Form.Item label={<Text className="pr_green">2. ปัญหาอุปสรรค (ถ้ามี)</Text>} name={"question_12"}>
                                                <Text>{agencyDetail[1].answer}</Text>
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}

                                {Validation.convertInst(agencyType) === "กองสื่อสารองค์กร" ||
                                Validation.convertInst(agencyType) === "กองการตลาด" ||
                                Validation.convertInst(agencyType) === "ฝ่ายบริหารผู้ประกอบการ" ||
                                (Validation.convertInst(agencyType) === "สำนักงานนิคมอุตสาหกรรม" &&
                                    (agencyName === "Line กลุ่มผู้ประกอบการ" ||
                                        agencyName === "โทรศัพท์ สำนักงานนิคมอุตสาหกรรม" ||
                                        agencyName === "ศูนย์บริการเบ็ดเสร็จครบวงจร (Total Solution Center : TSC)  / สำนักงานนิคมอุตสาหกรรม)")) ? (
                                    <>
                                        <Divider dashed style={{ margin: "0px 0px 0px 0px" }} />
                                        <Col span={24}>
                                            <Heading
                                                text={"สารสนเทศของลูกค้า ที่ได้รับจากช่องทางนั้นๆ"}
                                                size={4}
                                                style={{ margin: 0, color: token.thPrimary }}
                                            />
                                        </Col>
                                        {agencyDetail.length === 9 && (
                                        <Col span={18}>
                                            <Form.Item
                                                label={<Text className="pr_green">{"1. " + questionHeader[7]?.question}</Text>}
                                                name={"question_2"}
                                            >
                                                <Text style={{ fontSize: 14, fontWeight: 500, color: "#667085" }}>
                                                    <Text>{agencyDetail[7].answer}</Text>
                                                </Text>
                                            </Form.Item>
                                        </Col>
                                        )}
                                        <Col span={18}>
                                            <Form.Item
                                                label={<Text className="pr_green">{
                                                    agencyDetail.length === 9 
                                                    ? "2. " + questionHeader[2]?.question
                                                    : "1. " + questionHeader[2]?.question

                                                }</Text>}
                                                name={"question_2"}
                                            >
                                                <Text style={{ fontSize: 14, fontWeight: 500, color: "#667085" }}>
                                                    <Text>{
                                                    agencyDetail.length === 9 
                                                    ? agencyDetail[2].answer 
                                                    : agencyDetail.length === 8
                                                    ? agencyDetail[2].answer 
                                                    : agencyDetail[1].answer}
                                                    </Text>
                                                </Text>
                                            </Form.Item>
                                        </Col>
                                        
                                        <Col span={18}>
                                            <Form.Item
                                                label={<Text className="pr_green">{
                                                    agencyDetail.length === 9 
                                                    ? "3. " + questionHeader[3]?.question
                                                    : "2. " + questionHeader[3]?.question
                                                }</Text>}
                                                name={"question_3"}
                                            >
                                                <Text style={{ fontSize: 14, fontWeight: 500, color: "#667085" }}>
                                                    <Text>{
                                                    agencyDetail.length === 9 
                                                    ? agencyDetail[3].answer 
                                                    : agencyDetail.length === 8
                                                    ? agencyDetail[3].answer 
                                                    : agencyDetail[2].answer}</Text>
                                                </Text>
                                            </Form.Item>
                                        </Col>
{/*}                                        
                                        <Col span={16}>
                                            <Form.Item
                                                name={"question_4"}
                                                label={<Text className="pr_green">{
                                                    agencyDetail.length === 9 
                                                    ? "4. " + questionHeader[4]?.question
                                                    : "3. " + questionHeader[4]?.question
                                                }</Text>}
                                            >
                                                <Text>{
                                                agencyDetail.length === 9 
                                                ? agencyDetail[4].answer 
                                                : agencyDetail.length === 8 
                                                ? agencyDetail[4].answer 
                                                : agencyDetail[3].answer}</Text>
                                            </Form.Item>
                                        </Col>

                                        <Col span={16}>
                                            <Form.Item
                                                name={"question_5"}
                                                label={<Text className="pr_green">{
                                                    agencyDetail.length === 9 
                                                    ? "5. " + questionHeader[5]?.question
                                                    : "4. " + questionHeader[5]?.question
                                                }</Text>}
                                            >
                                                <Text>{
                                                agencyDetail.length === 9 
                                                ? agencyDetail[5].answer 
                                                : agencyDetail.length === 8
                                                ? agencyDetail[5].answer 
                                                : agencyDetail[4].answer}</Text>
                                            </Form.Item>
                                        </Col>

                                        <Col span={16}>
                                            <Form.Item
                                                name={"question_6"}
                                                label={<Text className="pr_green"> {
                                                    agencyDetail.length === 9 
                                                    ? "6. " + questionHeader[6]?.question
                                                    : "5. " + questionHeader[6]?.question
                                                }</Text>}
                                            >
                                                <Text>{
                                                agencyDetail.length === 9 
                                                ? agencyDetail[6].answer 
                                                : agencyDetail.length === 8
                                                ? agencyDetail[6].answer 
                                                : agencyDetail[5].answer}</Text>
                                            </Form.Item>
                                        </Col>
                                        <Col span={16}>
                                            <Form.Item name={"question_6"} label={<Text className="pr_green">แนบไฟล์</Text>}>
                                                <Link
                                                    onClick={() =>
                                                        DownloadFile(
                                                            agencyDetail.length === 9 
                                                            ? agencyDetail[8].answer 
                                                            : agencyDetail.length === 8
                                                            ? agencyDetail[7].answer 
                                                            : agencyDetail[6].answer)
                                                    }
                                                    underline
                                                >
                                                    <PaperClipOutlined style={{ paddingRight: 5 }} />
                                                    {fileName}
                                                    เอกสารประกอบข้อมูลลูกค้า.pdf
                                                </Link>
                                            </Form.Item>
                                        </Col>
*/}                           
{/* Inser New  NEW SECTION +++ VOC*/}
 <Col span={24}>
        <Divider dashed />
      </Col>
       <Col span={24}>
          <Heading
            text={"Voice of Customer"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>
                         

                          <Col span={24}>
                            <div style={{ fontWeight: 600, fontSize: 16 }}>
                              ด้านผลิตภัณฑ์และบริการ
                            </div>
                          </Col>

                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["productAndServiceWant", `${k}`]}
                              
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                placeholder="กรุณาเลือก"
                                //  value={
                                //     vocDetail.productAndServiceExpected
                                //         ?  Object.values(vocDetail.productAndServiceExpected ?? {}).flat()
                                //         : []
                                // }
                                disabled={true}
                               
                              >
                                {productRequirement &&
                                  productRequirement.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["productAndServiceWant", k]) &&
                              form
                                .getFieldValue(["productAndServiceWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={[
                                    "productAndServiceWantSpecify",
                                    `${k}`,
                                  ]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["productAndServiceExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                mode="multiple"
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                 
                                 disabled={true}
                              >
                                {otherProductExpect &&
                                  otherProductExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue([
                              "productAndServiceExpected",
                              k,
                            ]) &&
                              form
                                .getFieldValue(["productAndServiceExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={[
                                    "productAndServiceExpectedSpecify",
                                    `${k}`,
                                  ]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านสนับสนุนลูกค้า
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["supportWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                 disabled={true}
                              >
                                {customerSupport &&
                                  customerSupport.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["supportWant", k]) &&
                              form
                                .getFieldValue(["supportWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["supportWantSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["supportExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                disabled={true}
                              >
                                {otherSupportExpect &&
                                  otherSupportExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["supportExpected", k]) &&
                              form
                                .getFieldValue(["supportExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["supportExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านการทำธุรกรรม
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["transactionWant", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                                style={{
                                  width: "100%",
                                }}
                                 disabled={true}
                              >
                                {businessRequire &&
                                  businessRequire.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["transactionWant", k]) &&
                              form
                                .getFieldValue(["transactionWant", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["transactionWantSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["transactionExpected", `${k}`]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                
                                maxTagCount={"responsive"}
                                mode={"multiple"}
                                 disabled={true}
                              >
                                {otherBusinessExpect &&
                                  otherBusinessExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["transactionExpected", k]) &&
                              form
                                .getFieldValue(["transactionExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["transactionExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>

                          <Col span={24}>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                marginTop: 20,
                              }}
                            >
                              ด้านการจัดการความสัมพันธ์ (CRM)
                            </div>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="1.ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                              name={["crmExpected", `${k}`]}
                              rules={[
                                {
                                  required: true,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Select
                                allowClear
                                style={{
                                  width: "100%",
                                }}
                                disabled={true}
                                mode={"multiple"}
                                maxTagCount={"responsive"}
                              >
                                {customerExpect &&
                                  customerExpect.map((item) => (
                                    <Option
                                      key={item.vocUniqueId}
                                      value={item.vocUniqueId}
                                    >
                                      {item.vocDetailTh}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {form.getFieldValue(["crmExpected", k]) &&
                              form
                                .getFieldValue(["crmExpected", k])
                                .includes("-99") === true && (
                                <Form.Item
                                  label=""
                                  name={["crmExpectedSpecify", `${k}`]}
                                  style={{ marginTop: 8 }}
                                >
                                  <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                                </Form.Item>
                              )}
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="2.ข้อเสนอแนะด้านผลิตภัณฑ์และบริการ (ถ้ามี)"
                              name={["productAndServiceSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด"  disabled={true} />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="3.ข้อเสนอแนะด้านสนับสนุนลูกค้า (ถ้ามี)"
                              name={["supportSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด"  disabled={true} />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="4.ข้อเสนอแนะด้านการทำธุรกรรม (อนุมัติ, อนุญาตและสิทธิประโยชน์) (ถ้ามี)"
                              name={["transactionSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด"  disabled={true} />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="5.ข้อเสนอแนะด้านการจัดการความสัมพันธ์กับลูกค้า (CRM) (ถ้ามี)"
                              name={["crmSuggestion", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด"  disabled={true} />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="6.สิ่งที่ไม่พึ่งพอใจต้องการให้ปรับปรุงอย่างเร่งด่วน (ถ้ามี)"
                              name={["notSatisfied", `${k}`]}
                            >
                              <Input.TextArea placeholder="รายละเอียด"   disabled={true}/>
                            </Form.Item>
                          </Col>

{/* End Insert New */}             
                                    </>
                                ) : (
                                    <></>
                                )}
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
            <FloatButton.BackTop
                className="custom-float-btn"
                icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
                shape="square"
                style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
            />
        </WithSidebar>
    );
};
